module.exports = __webpack_public_path__ + "static/img/STGlogo.323bbe7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/STGlogo.png
// module id = kDlB
// module chunks = 1